import React from "react";

function TrackOfTheDayResults({ results, searchTerm }) {
  // console.log("🚀 ~ file: TrackOfTheDayResults.js:63 ~ TrackOfTheDayResults ~ results:", results);

  return (
    <div>
      {results && results.totd && results.totd.found && (
        <div className="resultsGroup">
          <div className="sectionTitle">TRACK OF THE DAY</div>
          <div className="sectionList">
            <ul>
              {results && results.totd && results.totd.tracks !== 0 && (
                <li>
                  »{" "}
                  <a href={`//www.dreamchimney.com/tracks/search?title=${searchTerm}`}>
                    {" "}
                    {results.totd.tracks} similar track title{results.totd.tracks !== 0 ? `s` : ``} found
                  </a>
                </li>
              )}
              {results && results.totd && results.totd.artists !== 0 && (
                <li>
                  »{" "}
                  <a href={`//www.dreamchimney.com/tracks/search?artist=${searchTerm}`}>
                    {" "}
                    {results.totd.artists} similar artist name{results.totd.artists !== 0 ? `s` : ``} found
                  </a>
                </li>
              )}
              {results && results.totd && results.totd.genres !== 0 && (
                <li>
                  »{" "}
                  <a href={`//www.dreamchimney.com/tracks/search?genre=${searchTerm}`}>
                    {" "}
                    {results.totd.genres} similar genre{results.totd.genres !== 0 ? `s` : ``} found
                  </a>
                </li>
              )}
              {results && results.totd && results.totd.albums !== 0 && (
                <li>
                  »{" "}
                  <a href={`//www.dreamchimney.com/tracks/search?album=${searchTerm}`}>
                    {" "}
                    {results.totd.albums} similar album title{results.totd.albums !== 0 ? `s` : ``} found
                  </a>
                </li>
              )}
              {results && results.totd && results.totd.messages !== 0 && (
                <li>
                  »{" "}
                  <a href={`//www.dreamchimney.com/tracks/message-board/search?terms=${searchTerm}`}>
                    {" "}
                    {results.totd.messages} message board post{results.totd.messages !== 0 ? `s` : ``} include this term
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
}

export default TrackOfTheDayResults;
